module.exports = __webpack_public_path__ + "images/logout-c5ece6b3.svg";